import React from 'react';
import SectionTitle from '../common/SectionTitle';

const SprintContentThree = () => {
  return (
    <>
      <section className='why-choose-us pt-60 pb-120'>
        <div className='container'>
          <div className='row justify-content-lg-between justify-content-center align-items-center'>
            <div className='col-lg-6 col-md-7 order-1 order-lg-0'>
              <div className='why-choose-img position-relative'>
                <img
                  src='assets/img/sprint3.jpg'
                  className='img-fluid rounded-custom'
                  alt='duel-phone'
                />
              </div>
            </div>
            <div className='col-lg-5 col-md-12 order-0 order-lg-1 '>
              <div className='why-choose-content'>
                <div className='mb-32'>
                  <h2 className='title2'>Exceed goals through collaboration and automation</h2>
                </div>
                <p>Clearly outline targets for your team, and exceed your goals with real-time collaboration, like @mentions and comments, and our powerful automation engine.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SprintContentThree;
